// import { IHeadingInputData } from './boomtypes';
import { IColorData } from "./../ui/types";
import { ICountry } from "./../../helpers/phone";
import { CurrentField } from "./types";
import { IValidationTypesFE, ValidationTypes } from "./validationTypes";

/* Field Editable Object Types */

// Commmon types
// Fields types

export interface IInputData {
    contentType: ContentType;
    defaultText: string;
    placeholder: string;
}

export interface IStyleLable {
    alignment: LabelAlignmentTypes;
    family: any;
    weight: string;
    size: string;
    isItalic: boolean;
    isUnderline: boolean;
    isStrikethrough: boolean;
    color: IColorData;
    length: number;
}

export interface IStyleInput {
    widthPx: number | null;
    widthPercent: number | null;
    height?: number | null;
    widthMeasurement: WidthMeasurement;
    fill: { color: IColorData };
    border: {
        radius: number;
        size: number;
        color: IColorData;
    };
}

export interface IStyleInputValue {
    alignment: AlignmentTypes;
    family: any;
    weight: string;
    size: string;
    isItalic: boolean;
    isStrikethrough: boolean;
    isUnderline: boolean;
    color: IColorData;
}

export interface IFieldLabelData {
    value: string;
    hidden: boolean;
    styles: IStyleLable;
}

export interface IFieldInputData {
    data: IInputData;
    styles: {
        input: IStyleInput;
        inputValue: IStyleInputValue;
    };
}

export interface IFieldSelectData {
    data: {
        contentType: ContentType;
        defaultText: string | null;
        placeholder: string;
    };
    styles: {
        input: IStyleInput;
        inputValue: IStyleInputValue;
    };
}

export interface IFieldRequired {
    value: boolean;
    message: string;
}

export enum ShowTypes {
    CHECKBOX = "Checkbox",
    RADIO = "Radio",
    TEXT = "Text",
    DROPDOWN = "Dropdown",
}

export enum AlignmentTypes {
    LEFT = "left",
    CENTER = "center",
    RIGHT = "right",
}
export enum TextAlignmentTypes {
    START = "start",
    CENTER = "center",
    END = "end",
}

export enum AligItemTypes {
    START = "start",
    CENTER = "center",
    END = "end",
}

export enum LabelAlignmentTypes {
    TOP_LEFT = "top_left",
    TOP_CENTER = "top_center",
    TOP_RIGHT = "top_right",
    LEFT = "left",
    RIGHT = "right",
}

export enum FileUploadAlignmentTypes {
    LEFT = "left",
    RIGHT = "right",
    CENTER = "center",
}

export enum FieldsType {
    Input = "INPUT",
}

export enum WidthMeasurement {
    PX = "Px",
    PERCENT = "Percent",
}

export enum FieldWidth {
    PartOfHalf = 1,
    Half,
    AlmostFull,
    Full,
}

export interface IFieldInput {
    width?: number;
    height?: number;
    radius?: number;
}

export enum FieldInputType {
    Width = "width",
    Height = "height",
    Radius = "radius",
}

export enum IFieldType {
    Width = "width",
}

export enum Selected {
    All = "SELECTED_ALL",
    MULTI = "SELECTED_MULTI",
}

export type CurrentInputEditing = CurrentField | Selected.All;

export enum ContentType {
    PLACEHOLDER = "placeholder",
    DEFAULT_TEXT = "defaultText",
}

/* -- I single line validation types -- */
interface ISingleLineTextValidation {
    [ValidationTypes.LETTERS]: IValidationTypesFE[ValidationTypes.LETTERS];
    [ValidationTypes.DIGITS]: IValidationTypesFE[ValidationTypes.DIGITS];
    [ValidationTypes.EMAIL]: IValidationTypesFE[ValidationTypes.EMAIL];
    [ValidationTypes.URL]: IValidationTypesFE[ValidationTypes.URL];
    [ValidationTypes.REGEX]: IValidationTypesFE[ValidationTypes.REGEX];
    [ValidationTypes.MIN_MAX_STRING_LENGTH]: IValidationTypesFE[ValidationTypes.MIN_MAX_STRING_LENGTH];
}

export interface IValidateInfo {
    enabled: boolean;
    text: string;
}

interface IFieldIcons {
    styles: IFieldInputData["styles"];
}

export interface ISingleLineText {
    label: IFieldLabelData;
    input: IFieldInputData;
    isRequired: IFieldRequired;
    validations: ISingleLineTextValidation;
    tooltip: IValidateInfo;
}

interface IPasswordValidation {
    [ValidationTypes.LETTERS]: IValidationTypesFE[ValidationTypes.LETTERS];
    [ValidationTypes.REGEX]: IValidationTypesFE[ValidationTypes.REGEX];
    [ValidationTypes.MIN_MAX_STRING_LENGTH]: IValidationTypesFE[ValidationTypes.MIN_MAX_STRING_LENGTH];
    [ValidationTypes.DIGITS]: IValidationTypesFE[ValidationTypes.DIGITS];
}

export interface IPasswordInputData {
    data: {
        placeholder: string;
    };
    styles: IFieldInputData["styles"];
}

export interface IPassword {
    label: IFieldLabelData;
    isShowLabel: boolean;
    isRequired: IFieldRequired;
    input: IPasswordInputData;
    validations: IPasswordValidation;
    tooltip: IValidateInfo;
    icon: IFieldIcons;
}

export enum NameInput {
    FIRST = "first_name",
    MIDDlE = "middle_name",
    LAST = "last_name",
}

export interface IName {
    label: IFieldLabelData;
    [NameInput.FIRST]: {
        input: IFieldInputData;
        isRequired: IFieldRequired;
    };
    [NameInput.MIDDlE]: {
        input: IFieldInputData;
        isRequired: IFieldRequired;
    };
    [NameInput.LAST]: {
        input: IFieldInputData;
        isRequired: IFieldRequired;
    };
    isShowLabel: boolean;
    isRequired: IFieldRequired;
    isMiddleName: boolean;
    validations: {};
    tooltip: IValidateInfo;
}

export interface IPhone {
    label: IFieldLabelData;
    isShowLabel: boolean;
    isRequired: IFieldRequired;
    defaultValue: string;
    input: {
        styles: IFieldInputData["styles"];
    };
    isPrefix: boolean;
    country: ICountry["key"];
    search: string;
    tooltip: IValidateInfo;
    validations: {
        [ValidationTypes.MIN_MAX_STRING_LENGTH]: IValidationTypesFE[ValidationTypes.MIN_MAX_STRING_LENGTH];
    };
    icon: IFieldIcons;
}

export enum NumberContentType {
    PLACEHOLDER = "placeholder",
    DEFAULT_VALUE = "defaultText",
}

export interface INumberInputData {
    data: {
        contentType: NumberContentType;
    };
    styles: IFieldInputData["styles"];
}

export interface ISelectOptionValueCustomModel {
    title: string;
    value: string;
}

/* -- Number Field Types -- */
export interface IPayableFieldsValueModel {
    min?: number;
    max?: number;
    enabled?: boolean;
}
export interface INumberValidation {
    [ValidationTypes.MIN_MAX_QUANTITY]: IValidationTypesFE[ValidationTypes.MIN_MAX_QUANTITY];
}
export interface IFileUploadValidation {
    [ValidationTypes.MIN_MAX_SIZE]: IValidationTypesFE[ValidationTypes.MIN_MAX_SIZE];
    [ValidationTypes.FILE_TYPE_FORMAT]: IValidationTypesFE[ValidationTypes.FILE_TYPE_FORMAT];
}

export interface INumber {
    label: IFieldLabelData;
    input: INumberInputData;
    isShowLabel: boolean;
    isRequired: IFieldRequired;
    placeholder: string;
    defaultValue: string;
    arrows: boolean;
    validations: INumberValidation;
    tooltip: IValidateInfo;
    value: IPayableFieldsValueModel;
    icon: IFieldIcons;
}

/* -- Date Field Types -- */

export interface IDateInputData {
    data: {
        contentType: ContentType;
        defaultText: string;
        placeholder: string;
    };
    styles: IFieldInputData["styles"];
}

export interface IDateValidation {
    [ValidationTypes.MIN_MAX_DATE]: IValidationTypesFE[ValidationTypes.MIN_MAX_DATE];
}

export interface IDate {
    label: IFieldLabelData;
    input: IDateInputData;
    isShowLabel: boolean;
    isRequired: IFieldRequired;
    tooltip: IValidateInfo;
    isActive: boolean;
    validations: IDateValidation;
    icon: IFieldIcons;
}

interface IChoicesInputStyle {
    alignment: AlignmentTypes;
    size: string;
    fill: { color: IColorData };
}

export interface IStarRatingInput {
    styles: IChoicesInputStyle;
}

export interface IStarRating {
    label: IFieldLabelData;
    input: IFieldInputData;
    isShowLabel: boolean;
    starsCount: number;
    defaultValue: number;
    isRequired: IFieldRequired;
    isCircle: boolean;
    isFilled?: boolean;
    tooltip: IValidateInfo;
    validations: {};
}

export enum ScaleRatingInputs {
    LEFT_INPUT = "left",
    MIDDLE_INPUT = "middle",
    RIGHT_INPUT = "right",
}

export interface IScaleRatingBottomInputs {
    label: string;
    input: IFieldInputData;
    enabled: boolean;
}

export interface IScaleRating {
    label: IFieldLabelData;
    input: IFieldInputData;
    tooltip: IValidateInfo;
    isRequired: IFieldRequired;
    defaultValue: null | number;
    startValue: number;
    endValue: number;
    [ScaleRatingInputs.LEFT_INPUT]: IScaleRatingBottomInputs;
    [ScaleRatingInputs.MIDDLE_INPUT]: IScaleRatingBottomInputs;
    [ScaleRatingInputs.RIGHT_INPUT]: IScaleRatingBottomInputs;
}

export interface IUrlInputData {
    value: string;
    styles: IStyleLable;
}

export interface IUrl {
    label: IFieldLabelData;
    input: IFieldInputData;
    isShowLabel: boolean;
    isRequired: IFieldRequired;
    tooltip: IValidateInfo;
    validations: {};
}
export interface IDomainValidation {
    isDomainEnabled: boolean;
    value: string;
}
export interface IEmailValidation {
    [ValidationTypes.DOMAIN]: IValidationTypesFE[ValidationTypes.DOMAIN];
    [ValidationTypes.REGEX]: IValidationTypesFE[ValidationTypes.REGEX];
}
export interface IEmail {
    label: IFieldLabelData;
    input: IFieldInputData;
    isShowLabel?: boolean;
    isRequired: IFieldRequired;
    tooltip: IValidateInfo;
    validations: IEmailValidation;
}

export enum AddressInput {
    STREET_ADDRESS = "address_1",
    STREET_ADDRESS_TWO = "address_2",
    CITY = "city",
    STATE = "state",
    ZIP_CODE = "zip_code",
    SELECT_COUNTRY = "country",
}

interface IAddressInput {
    input: IFieldInputData;
    label: IFieldLabelData;
    isRequired: IFieldRequired;
}

interface IAddressSelcet {
    input: IFieldSelectData;
    label: IFieldLabelData;
    isRequired: IFieldRequired;
    icon: IFieldIcons;
}

interface IAddressOrder {
    [AddressInput.STREET_ADDRESS]: boolean;
    [AddressInput.STREET_ADDRESS_TWO]: boolean;
    [AddressInput.CITY]: boolean;
    [AddressInput.STATE]: boolean;
    [AddressInput.ZIP_CODE]: boolean;
    [AddressInput.SELECT_COUNTRY]: boolean;
}

export interface IAddress {
    label: IFieldLabelData;
    [AddressInput.STREET_ADDRESS]: IAddressInput;
    [AddressInput.STREET_ADDRESS_TWO]: IAddressInput;
    [AddressInput.CITY]: IAddressInput;
    [AddressInput.STATE]: IAddressInput;
    [AddressInput.ZIP_CODE]: IAddressInput;
    [AddressInput.SELECT_COUNTRY]: IAddressSelcet;
    order: IAddressOrder;
    isRequired: IFieldRequired;
    isShowLabel: boolean;
    tooltip: IValidateInfo;
    validations: {};
}

export interface ITerms {
    label: IFieldLabelData;
    input: IFieldInputData;
    tooltip: IValidateInfo;
    isRequired: IFieldRequired;
    isChecked: boolean;
    url: string;
    text: string;
    validations: {};
    icon: IFieldIcons;
}

export interface IHeadingInputData {
    styles: {
        input: {};
        inputValue: IStyleInputValue;
    };
}
export interface IHeading {
    label: IFieldLabelData;
    input: IHeadingInputData;
    isRequired: IFieldRequired;
    isShowLabel: boolean;
    isActive: boolean;
    tooltip: IValidateInfo;
    text: string;
    validations: {};
}

export interface IMultiLineText {
    label: IFieldLabelData;
    input: IFieldInputData;
    isRequired: IFieldRequired;
    isRichText: boolean;
    validations: IMultiLineTextValidation;
    tooltip: IValidateInfo;
}

export interface IDescriptionInputData {
    styles: {
        input: {};
        inputValue: IStyleInputValue;
    };
}
export interface IDescription {
    label: IFieldLabelData;
    input: IDescriptionInputData;
    isRequired: IFieldRequired;
    isShowLabel: boolean;
    isActive: boolean;
    tooltip: IValidateInfo;
    html: string;
    validations: {};
}

interface IMultiLineTextValidation {
    [ValidationTypes.LETTERS]: IValidationTypesFE[ValidationTypes.LETTERS];
    [ValidationTypes.DIGITS]: IValidationTypesFE[ValidationTypes.DIGITS];
    [ValidationTypes.URL]: IValidationTypesFE[ValidationTypes.URL];
    [ValidationTypes.REGEX]: IValidationTypesFE[ValidationTypes.REGEX];
    [ValidationTypes.EMAIL]: IValidationTypesFE[ValidationTypes.EMAIL];
    [ValidationTypes.MIN_MAX_STRING_LENGTH]: IValidationTypesFE[ValidationTypes.MIN_MAX_QUANTITY];
}
export interface IPriceValidations {
    [ValidationTypes.MIN_MAX_QUANTITY]: IValidationTypesFE[ValidationTypes.MIN_MAX_QUANTITY];
}

export interface ITimeValidations {
    [ValidationTypes.MIN_MAX_DATE]: IValidationTypesFE[ValidationTypes.MIN_MAX_DATE];
}
interface ITimeDropdown {
    data: IInputData;
    styles: {
        input: IStyleInput;
        inputValue: IStyleInputValue;
    };
    icon: IFieldIcons;
}

export interface ITime {
    label: IFieldLabelData;
    input: IFieldInputData;
    isRequired: IFieldRequired;
    tooltip: IValidateInfo;
    format?: string;
    defaultValue?: string;
    validations: ITimeValidations;
    dropdown_input: ITimeDropdown;
}

export interface IPriceValidations {
    [ValidationTypes.MIN_MAX_QUANTITY]: IValidationTypesFE[ValidationTypes.MIN_MAX_QUANTITY];
}

export interface IPrice {
    label: IFieldLabelData;
    input: IFieldInputData;
    tooltip: IValidateInfo;
    isRequired: IFieldRequired;
    placeholder?: string;
    defaultValue?: string;
    currency: ICurrencyData;
    validations: IPriceValidations;
    value: IPayableFieldsValueModel;
}

export interface ICurrencyData {
    value: string;
    input: IFieldInputData;
}

export interface ICheckboxInputData {
    data: {
        placeholder: string;
        defaultText: number;
    };
    styles: IFieldInputData["styles"];
}

export interface ICheckboxValidation {
    [ValidationTypes.MIN_MAX_OPTIONS]: IValidationTypesFE[ValidationTypes.MIN_MAX_OPTIONS];
}

export interface IPaymentOptions {
    enabled: boolean;
    quantity: {
        enabled: boolean;
        value?: number;
    };
    custom?: {
        enabled: boolean;
        value: ISelectOptionValueCustomModel[];
    };
}
export interface ISelectOptionValueCustomModel {
    title: string;
    enabled: boolean;
    value: string;
}

export interface ICheckbox {
    label: IFieldLabelData;
    input: IFieldInputData;
    isRequired: IFieldRequired;
    column_quantity: number;
    tooltip: IValidateInfo;
    checkedOptions: string;
    validations: ICheckboxValidation;
    icon: IFieldIcons;
    options: null | number[];
    paymentOptions: IPaymentOptions;
}

export interface IMapGeaometry {
    lat: number;
    lng: number;
}

export interface IMapMarker {
    _id: string;
    location: string;
    description: string;
    geometry: IMapGeaometry;
}

export interface IMapMarkersRes {
    [id: string]: IMapMarker[];
}

export interface IMapGeaometry {
    lat: number;
    lng: number;
}

export interface IMap {
    label: IFieldLabelData;
    input: IFieldInputData;
    center: IMapGeaometry;
    zoom: number;
    markers: null | number[];
    isRequired: IFieldRequired;
    validations: [];
    tooltip: IValidateInfo;
}

export interface ISelectableOption {
    label: string;
    isOther?: boolean;
}

export interface ICheckboxOption extends ISelectableOption {}

export interface IRadioOption extends ISelectableOption {}

export interface IOptions {
    options: ICheckboxOption[];
}

export interface IRadioInputData {
    data: {
        placeholder: string;
        defaultText: number;
    };
    styles: IFieldInputData["styles"];
}

export interface ISignature {
    label: IFieldLabelData;
    input: IFieldInputData;
    isRequired: IFieldRequired;
    tooltip: IValidateInfo;
    showLine: boolean;
    icon: IFieldIcons;
    validations: {};
}
export interface IFileUpload {
    label: IFieldLabelData;
    input: IFieldInputData;
    isRequired: IFieldRequired;
    isMultiple: boolean;
    extensions: string;
    tooltip: IValidateInfo;
    icon: IFieldIcons;
    validations: IFileUploadValidation;
}

export interface ITimeZone {
    label: IFieldLabelData;
    input: IFieldInputData;
    isRequired: IFieldRequired;
    defaultValue: string;
    tooltip: IValidateInfo;
    byIpLocation: boolean;
    icon: IFieldIcons;
    validations: {};
}

export interface ICustomHTML {
    label: IFieldLabelData;
    input: IFieldInputData;
    html: string;
    isRequired: IFieldRequired;
    tooltip: IValidateInfo;
    validations: {};
}

export interface IDropdownOption extends ISelectableOption {}

export interface IDropdown {
    label: IFieldLabelData;
    input: IFieldInputData;
    tooltip: IValidateInfo;
    isRequired: IFieldRequired;
    defaultValue: string;
    options: null | number[];
    validations: [];
    paymentOptions: IPaymentOptions;
    icon: IFieldIcons;
}

export interface IRadio {
    label: IFieldLabelData;
    input: IFieldInputData;
    tooltip: IValidateInfo;
    isRequired: IFieldRequired;
    defaultValue: string;
    options: null | number[];
    validations: {};
    paymentOptions: IPaymentOptions;
    icon: IFieldIcons;
    column_quantity: number;
}

interface IPromoCodeFieldButton {
    enabled: boolean;
    styles: IFieldInputData["styles"];
    defaultText: string;
}
export interface IPaymentPromoCode {
    label: IFieldLabelData;
    tooltip: IValidateInfo;
    placeholder: string;
    defaultText: string;
    input: IFieldInputData;
    icon: IFieldIcons;
    isRequired: IFieldRequired;
    button: IPromoCodeFieldButton;
}

export interface IPaymentPaymentMethod {
    label: IFieldLabelData;
    tooltip: IValidateInfo;
    placeholder: string;
    input: IFieldInputData;
    icon: IFieldIcons;
    isRequired: IFieldRequired;
}

export interface IInputTableField {
    label: IFieldLabelData;
    input: IFieldInputData;
    isRequired: IFieldRequired;
    icon: IFieldIcons;
    tooltip: IValidateInfo;
    showType: ShowTypes;
    dropdownOptions: string[];
    rows: string[];
    columns: string[];
    cell: IFieldInputData;
    validations: {};
    cells: {
        [key: string]: string | boolean;
    };
}

export type IBoomformField =
    | ISingleLineText
    | IPassword
    | IName
    | IPhone
    | INumber
    | IDate
    | IStarRating
    | IUrl
    | IAddress
    | IEmail
    | IScaleRating
    | IHeading
    | ITerms
    | IMultiLineText
    | IMap
    | ITime
    | IPrice
    | IDescription
    | ICheckbox
    | ICustomHTML
    | IRadio
    | ISignature
    | IFileUpload
    | IDropdown
    | IPaymentPromoCode
    | IPaymentPaymentMethod
    | ITimeZone
    | IInputTableField;

export type IBoomformFields = { [key: string]: IBoomformField };
